module.exports = __webpack_public_path__ + "img/DW365-278.13829b58.jpg";